import { render, staticRenderFns } from "./CourseRegistration.vue?vue&type=template&id=576c3c9b&scoped=true"
import script from "./CourseRegistration.vue?vue&type=script&lang=js"
export * from "./CourseRegistration.vue?vue&type=script&lang=js"
import style0 from "./CourseRegistration.vue?vue&type=style&index=0&id=576c3c9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c3c9b",
  null
  
)

export default component.exports